/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Timeline_Zoom_InInputs */



/**
* | output |
* | --- |
* | "Zoom In" |
*
* @param {Shortcut_Keys_Name_Timeline_Zoom_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_timeline_zoom_in = /** @type {((inputs?: Shortcut_Keys_Name_Timeline_Zoom_InInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Timeline_Zoom_InInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Zoomer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vergrößern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ingrandisci")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Увеличить масштаб")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dar un golpe de zoom")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("放大")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ズームイン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ज़ूम इन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ampliar")
	return /** @type {LocalizedString} */ ("Zoom In")
});